import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';


const Investiture2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/01.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/02.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/03.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/04.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/05.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/06.webp`;
    const p7 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/7.webp`;
    const p8 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/8.webp`;
    const p9 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/9.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/11.webp`;
    const p12 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/12.webp`;
    const p13 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/13.webp`;
    const p14 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/14.webp`;
    const p15 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/15.webp`;
    const p16 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/16.webp`;
    const p17 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/17.webp`;
    const p18 = `${config.base_image_url_2025}/home/events-activities/school-programs/investiture/18.webp`;
  
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 2,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 2,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 2,
            cols: 1,
        }, {
            src: p5,
            source: p5,
            rows: 2,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 2,
            cols: 1,
        }, 
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 2,
            cols: 1,
        },
        {
          src: p10,
          source: p10,
          rows: 2,
          cols: 1,
        }, 
        {
        src: p11,
        source: p11,
        rows: 2,
        cols: 1,
       },
       {
        src: p12,
        source: p12,
        rows: 2,
        cols: 1,
       },
       {
        src: p13,
        source: p13,
        rows: 1.7,
        cols: 2,
       },
       {
        src: p14,
        source: p14,
        rows: 1.7,
        cols: 2,
       }, 
       {
        src: p15,
        source: p15,
        rows: 1.8,
        cols: 2,
       },
       {
        src: p16,
        source: p16,
        rows: 1.7,
        cols: 2,
       }, 
       {
        src: p17,
        source: p17,
        rows: 1.7,
        cols: 2,
        },
        // {
        // src: p18,
        // source: p18,
        // rows: 1.5,
        // cols: 2,
        // },


    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                Investiture Ceremony
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Date: 20 June 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                               National Public School Yeshwanthpur held the Investiture Ceremony 2025 on Friday, 20 June for the newly elected student council, house leaders, discipline leaders, various club and association representatives was held with dignity and splendour. The event commenced with a ceremonial march-past by the newly elected student leaders, showcasing discipline and pride. Clad in immaculate uniforms and bearing the house flags, the students displayed remarkable discipline and coordination, setting the tone for the event. The Principal, along with the Vice-Principal, Assistant Principals and Coordinators conferred badges, sashes and flags to the office bearers, formally entrusting them with their responsibilities.   
                                    <br></br>
                                    The School Prefect administered the oath of office, followed by delivering an inspiring acceptance speech expressing gratitude for the trust placed in them and promising to fulfil the responsibilities with sincerity. The Principal, Ms. Sheeja Manoj, addressed the gathering and acknowledged the collective efforts of all stakeholders who contributed to the smooth conduct of the event. She emphasized that while positions may distract, true leadership aligns one with responsibility. Ma’am also urged the student leaders to transform NPS Yeshwanthpur into a hub of learning and an icon of discipline and create moments to cherish. The event concluded on a note of pride and renewed commitment to excellence.

                                   
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Lead with purpose, serve with heart and inspire others by your example.”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Investiture2025;